import { Api } from 'utils';

class BannersService {
	
	static get = async (params?: any) => Api.createResponse('admin/banners/get',params);
	static getSelects = async (params?: any) => Api.createResponse('admin/banners/selects',params);
	static create = async (params?: any) => Api.createResponse('admin/banners/create',params);
	static delete = async (params?: any) => Api.createResponse('admin/banners/delete',params);

}

export default BannersService;